import { createDomain, sample } from 'effector'
import { AxiosErrorType, Driver } from '~/shared/api'
import { logger } from '~/shared/lib/logger'
import { notificationModalOpen } from '~/shared/lib/notificationModal'

const domain = createDomain('widgets.profile.ui.driverDeletionDetailsDrawer')

export const createDeletionRequest = domain.createEvent<{ fn: () => void }>()
export const createDeletionRequestFx = domain.createEffect<
  { fn: () => void },
  void,
  AxiosErrorType
>({
  async handler({ fn }) {
    await Driver.createDeletionRequest()
    fn()
  },
})

sample({
  clock: createDeletionRequest,
  target: createDeletionRequestFx,
})

sample({
  clock: createDeletionRequestFx.doneData,
  fn() {
    return {
      title: 'Удаление аккаунта',
      description: `Заявка на удаление аккаунта принята`,
      variant: 'success' as const,
    }
  },
  target: notificationModalOpen,
})

sample({
  clock: createDeletionRequestFx.failData,
  fn(e) {
    logger.error(e)
    return {
      title: 'Ошибка удаления аккаунта!',
      description: 'Обратитесь к администратору',
      variant: 'error' as const,
    }
  },
  target: notificationModalOpen,
})
